import { comparePlainDates, plainDateFromLegacy } from '../../core/services/plain-date';

/**
 * True when `start` falls on or before `due`.
 *
 * Both sides may be a genuine `YYYY-MM-DD` picked from an `<input type="date">`, but at least one
 * of them can also be a STORED value — `date-selector.tsx`'s `dateValidator` passes the sibling
 * field straight out of the database. On any database the plain-date migration hasn't run
 * against, that stored value is still a legacy ISO instant (`2026-08-25T12:00:00.000Z`), so both
 * sides are normalised through `plainDateFromLegacy` before comparing, the same treatment the
 * `plain-date` primitives already got. A side that cannot be decoded at all is a real error, not
 * a legacy value, and fails the range rather than guessing.
 *
 * A missing side is not an error: a step may have only one of the two.
 */
export const isValidDateRange = (start?: string | null, due?: string | null): boolean => {
  if (!start || !due) return true;

  const normalisedStart = plainDateFromLegacy(start);
  const normalisedDue = plainDateFromLegacy(due);
  if (!normalisedStart || !normalisedDue) return false;

  return comparePlainDates(normalisedStart, normalisedDue) <= 0;
};
